import React from 'react';

//https://reactjs.org/docs/lists-and-keys.html#extracting-components-with-keys
class FaqItem extends React.Component {

	constructor() {
		super();
	}
	
	//https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
	excerpt() {
        let excerpt = this.props.excerpt;
        return { __html: excerpt };			
	}

	render() {

		return (
			<li className="content-box faq__item item--home">
				<div className="box__body">
					<h3 className="faq__title">{this.props.title}</h3>
					<p className="faq__excerpt" dangerouslySetInnerHTML={this.excerpt()} />
					<a className="button button--silent" href={this.props.url}>{l18n.cta}<img loading="lazy" className="ico" src={`${wp_core.theme_url}/assets/img/ico/arrow.svg`} /></a>
				</div>
				<div className="faq__image">
					<div>
						<figure className="box__cover cover">
							<img loading="lazy" src={`${wp_core.theme_url}/assets/img/homepage/faq-${this.props.index}.jpg`} />
						</figure>
					</div>
				</div>
			</li>
		);
	}
}

export default FaqItem;